import axios from 'axios'

const BASE_URL = 'https://www.xiaofeijingji.com.cn'
// const BASE_URL = 'http://xryly.zgsbk.cn'
const api = axios.create({
  baseURL: `${BASE_URL}/index.php/api/` // 设置基本的请求URL
})

const commonAxios = async (method, url, data = null, params = null) => {
  try {
    const response = await api.request({
      method: method,
      url: url,
      data: data,
      params: params
    })

    return response.data
  } catch (error) {
    console.error('请求出错:', error)
  }
}

const searchParams = new URLSearchParams(window.location.search)
const ljhdid = searchParams.get('ljhdid') || ''

const getIndexList = () => commonAxios('GET', 'index/index' + (ljhdid ? `?year=${ljhdid}` : ''))
const getBannerList = () =>
  commonAxios('GET', 'index/bannerlist' + (ljhdid ? `?year=${ljhdid}` : ''))
const getDownFile = () => commonAxios('GET', 'index/downFile' + (ljhdid ? `?year=${ljhdid}` : ''))
const getBanerimgList = () =>
  commonAxios('GET', 'index/banerimgList' + (ljhdid ? `?year=${ljhdid}` : ''))
const applicationAdd = url => commonAxios('GET', url + (ljhdid ? `&year=${ljhdid}` : ''))
const getNewList = url => commonAxios('GET', url + (ljhdid ? `&year=${ljhdid}` : ''))
const getArchiveShow = url => commonAxios('GET', url + (ljhdid ? `&year=${ljhdid}` : ''))
const getAboutShow = () => commonAxios('GET', 'index/aboutShow' + (ljhdid ? `?year=${ljhdid}` : ''))
const getOrganizationShow = () =>
  commonAxios('GET', 'index/organizationShow' + (ljhdid ? `?year=${ljhdid}` : ''))
const getFooter = () => commonAxios('GET', 'index/footer' + (ljhdid ? `?year=${ljhdid}` : ''))
const getAwardsList = () =>
  commonAxios('GET', 'index/awardsList' + (ljhdid ? `?year=${ljhdid}` : ''))
const getYwzxList = () => commonAxios('GET', 'index/ywzxlist' + (ljhdid ? `?year=${ljhdid}` : ''))
const qyfcList = () => commonAxios('GET', 'index/qyfcList' + (ljhdid ? `?year=${ljhdid}` : ''))
const getYear = url => commonAxios('GET', url)
const getZxslList = () => commonAxios('GET', 'index/zxslList' + (ljhdid ? `?year=${ljhdid}` : ''))
const getNewCateList = () =>
  commonAxios('GET', 'index/newCateList' + (ljhdid ? `?year=${ljhdid}` : ''))

export {
  BASE_URL,
  getBannerList,
  getIndexList,
  getDownFile,
  applicationAdd,
  getBanerimgList,
  getNewList,
  getArchiveShow,
  getAboutShow,
  getOrganizationShow,
  getFooter,
  getAwardsList,
  getYwzxList,
  qyfcList,
  getYear,
  getZxslList,
  getNewCateList
}
